import React, { useEffect } from 'react'
import { func, object } from 'prop-types'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import { authenticationMessages, userMenuMessages } from '../../../translations'
import { baseTiltifyUrl } from '../../../utils/tiltifyUrl'
import { Button } from '../../Button'
import { Form, useFormContext } from '../../Form'
import { EmailInput, PasswordInput } from '../Inputs'
import { Social } from '../Social'
import { SubmitButton } from '../SubmitButton'
import { CauseSection } from './CauseSection'

const StyledHeading = styled.div`
  font-size: ${rem(24)};
  font-weight: bold;
  text-align: center;
  margin-bottom: ${rem(24)};
  color: ${({ theme }) => theme.textColor};
`

const StyledLoginFooter = styled.div`
  margin: ${rem(26)} -${rem(29)} 0;
  padding: ${rem(18)} ${rem(16)} 0;
  border-top: 1px solid ${({ theme }) => theme.borderColor};
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => `(max-width: ${theme.breakpoints[0]})`} {
    flex-direction: column;
    text-align: center;
  }
`

const ErrorDiv = styled.div`
  background-color: ${({ theme }) => theme.danger};
  padding: 0.5rem;
  text-align: center;
`

const StyledButton = styled(Button)`
  text-decoration: underline;
  color: ${({ theme }) => theme.lightBlue};
  font-weight: bold;
  font-size: ${rem(14)};
`

const SubButton = ({ externalErrors }) => {
  const { formatMessage } = useIntl()
  const { isSubmitting, setSubmitting, errors } = useFormContext()

  useEffect(() => {
    if (errors || externalErrors) {
      setSubmitting(false)
    }
  }, [externalErrors, errors])
  return (
    <SubmitButton loading={isSubmitting}>{formatMessage(userMenuMessages.signInText)}</SubmitButton>
  )
}

SubButton.propTypes = {
  externalErrors: object,
}

export const LoginFlow = ({ handleRedirect, onFlowChange, onLogin, openChild, errors }) => {
  const { formatMessage } = useIntl()
  const onSubmit = (values) => {
    onLogin(values)
  }

  useEffect(() => {}, [errors])

  return (
    <div id='gtm_login'>
      <StyledHeading>{formatMessage(authenticationMessages.signInToContinue)}</StyledHeading>
      <Form
        initialValues={{
          email: '',
          password: '',
        }}
        onSubmit={onSubmit}
      >
        {errors && errors.message ? <ErrorDiv>{errors.message}</ErrorDiv> : null}
        <EmailInput />
        <PasswordInput />
        <SubButton externalErrors={errors} />
      </Form>
      <Social token={handleRedirect} openChild={openChild} />
      <CauseSection />

      <StyledLoginFooter>
        <StyledButton forwardedAs='a' href={`${baseTiltifyUrl()}/users/password/new`}>
          {formatMessage(authenticationMessages.forgotPassword)}
        </StyledButton>
        <StyledButton onClick={onFlowChange}>
          {formatMessage(authenticationMessages.createAnAccount)}
        </StyledButton>
      </StyledLoginFooter>
    </div>
  )
}

LoginFlow.propTypes = {
  onFlowChange: func,
  onLogin: func,
  errors: object,
  handleRedirect: func,
  openChild: func,
}
